import { NavLink } from 'react-router-dom'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Icon, Image } from '@/ui'
import { MobileMenu } from '../MobileMenu'

interface HeaderProps {
  className?: string
  device: string
  handleIconClick: () => void
  isOpen: boolean
}

export const Header = ({
  className,
  device,
  isOpen,
  handleIconClick,
}: HeaderProps) => {
  return (
    <header
      className={`flex items-center justify-between w-full h-12 px-2 ${className}`}
    >
      <div className="flex items-center">
        {isOpen && (
          <NavLink to="/dashboard" className="flex items-center">
            {device === 'desktop' ? (
              <Image
                src="https://heard-images.s3.amazonaws.com/assets/heard_logo_green_2x.png"
                alt="heard logo"
                width={60}
              />
            ) : (
              <MobileMenu
                onClick={handleIconClick}
                onKeyDown={handleIconClick}
                isOpen={isOpen}
              />
            )}
          </NavLink>
        )}
      </div>

      <Icon
        className="cursor-pointer hover:text-neutral-300 transition-colors"
        color="text-neutral-600"
        icon={regular('angles-left')}
        onClick={handleIconClick}
        size="lg"
      />
    </header>
  )
}
